// extracted by mini-css-extract-plugin
export default {"FXPair":"FXPair_FXPair__ngZDv","currencyCode":"FXPair_currencyCode__xF4lS","currencyName":"FXPair_currencyName__dpiws","fXRate":"FXPair_fXRate__VAF4G"};